export default __webpack_public_path__ + "static/media/referenzen_intro_web-xs@2x.6f81f685.webp";